export default "__VITE_ASSET__CmXWIO56__"